var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav navbar-nav",attrs:{"id":"main-menu-navigation"}},_vm._l((_vm.items),function(item){return _c(_vm.resolveNavComponent(item),{key:item.header || item.title,tag:"component",attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }